import React from "react";

const EditEncounter: React.FunctionComponent = () => <div>This is where you will go to edit an encounter!</div>;

export default EditEncounter;
